// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IO5V","question":"styles_question__1IAxh","inputVisibleButton":"styles_inputVisibleButton__2SN7y","note":"styles_note__RYcTt"};